import React from 'react'

import { strings } from './station-with-item-ranks-content'
import styles from '../../styles/modules/users/users-query.module.scss'

interface Props {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  id: number
}

const QueryStationId: React.FC<Props> = props => (
  <div className={styles.container}>
    <span className={styles.title}>{strings.queryStationIdTitle}</span>
    <div className={styles.box}>
      <div className={styles.wrapper}>
        <input
          placeholder="ステーションID"
          value={props.id || ''}
          onChange={props.onChange}
        />
      </div>
    </div>
  </div>
)

export default QueryStationId
